"use strict";
// tslint:disable
/**
 * supply-reporting
 * A reporting API for supply partners in all verticals.  Find all details and links here: https://github.com/EVENFinancial/supply-reporting
 *
 * The version of the OpenAPI document: 1.1.0-rc.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavingsApi = exports.SavingsApiFactory = exports.SavingsApiFp = exports.SavingsApiAxiosParamCreator = exports.LoanApi = exports.LoanApiFactory = exports.LoanApiFp = exports.LoanApiAxiosParamCreator = exports.LifeInsuranceApi = exports.LifeInsuranceApiFactory = exports.LifeInsuranceApiFp = exports.LifeInsuranceApiAxiosParamCreator = exports.CreditCardApi = exports.CreditCardApiFactory = exports.CreditCardApiFp = exports.CreditCardApiAxiosParamCreator = exports.AdminApi = exports.AdminApiFactory = exports.AdminApiFp = exports.AdminApiAxiosParamCreator = exports.SummaryGroupBy = exports.ProductType = exports.LoanPurpose = exports.CreditRating = void 0;
var globalImportUrl = require("url");
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
var CreditRating;
(function (CreditRating) {
    CreditRating["Excellent"] = "excellent";
    CreditRating["Good"] = "good";
    CreditRating["Fair"] = "fair";
    CreditRating["Poor"] = "poor";
    CreditRating["Limited"] = "limited";
    CreditRating["Unknown"] = "unknown";
})(CreditRating = exports.CreditRating || (exports.CreditRating = {}));
/**
 *
 * @export
 * @enum {string}
 */
var LoanPurpose;
(function (LoanPurpose) {
    LoanPurpose["Auto"] = "auto";
    LoanPurpose["AutoPurchase"] = "auto_purchase";
    LoanPurpose["AutoRefinance"] = "auto_refinance";
    LoanPurpose["Baby"] = "baby";
    LoanPurpose["Boat"] = "boat";
    LoanPurpose["Business"] = "business";
    LoanPurpose["CarRepair"] = "car_repair";
    LoanPurpose["Cosmetic"] = "cosmetic";
    LoanPurpose["CreditCardRefi"] = "credit_card_refi";
    LoanPurpose["DebtConsolidation"] = "debt_consolidation";
    LoanPurpose["Emergency"] = "emergency";
    LoanPurpose["Engagement"] = "engagement";
    LoanPurpose["Green"] = "green";
    LoanPurpose["HomeImprovement"] = "home_improvement";
    LoanPurpose["HomePurchase"] = "home_purchase";
    LoanPurpose["HomeRefi"] = "home_refi";
    LoanPurpose["HouseholdExpenses"] = "household_expenses";
    LoanPurpose["LargePurchases"] = "large_purchases";
    LoanPurpose["LifeEvent"] = "life_event";
    LoanPurpose["MedicalDental"] = "medical_dental";
    LoanPurpose["Motorcycle"] = "motorcycle";
    LoanPurpose["MovingRelocation"] = "moving_relocation";
    LoanPurpose["Other"] = "other";
    LoanPurpose["Rv"] = "rv";
    LoanPurpose["SpecialOccasion"] = "special_occasion";
    LoanPurpose["StudentLoan"] = "student_loan";
    LoanPurpose["StudentLoanRefi"] = "student_loan_refi";
    LoanPurpose["Taxes"] = "taxes";
    LoanPurpose["Unknown"] = "unknown";
    LoanPurpose["Vacation"] = "vacation";
    LoanPurpose["Wedding"] = "wedding";
})(LoanPurpose = exports.LoanPurpose || (exports.LoanPurpose = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ProductType;
(function (ProductType) {
    ProductType["CreditCard"] = "credit_card";
    ProductType["Insurance"] = "insurance";
    ProductType["LifeInsurance"] = "life_insurance";
    ProductType["Loan"] = "loan";
    ProductType["Mortgage"] = "mortgage";
    ProductType["Savings"] = "savings";
    ProductType["Other"] = "other";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var SummaryGroupBy;
(function (SummaryGroupBy) {
    SummaryGroupBy["Day"] = "day";
    SummaryGroupBy["CreditRating"] = "credit_rating";
    SummaryGroupBy["LoanPurpose"] = "loan_purpose";
    SummaryGroupBy["PolicyType"] = "policy_type";
    SummaryGroupBy["Referrer"] = "referrer";
    SummaryGroupBy["LeadClientTag"] = "lead_client_tag";
})(SummaryGroupBy = exports.SummaryGroupBy || (exports.SummaryGroupBy = {}));
/**
 * AdminApi - axios parameter creator
 * @export
 */
exports.AdminApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Kicks off a lead funnel recalculation job. The job must be scoped to a single supply sub-account, and may be further limited to a subset of leads for that supply sub-account.  The request will respond immediately with the incomplete `LeadFunnelRecalculation` resource and start a background thread to load the requested leads from the replication hub replica and publish them to the `supply-reporting-lead-recalculations` Kafka topic. Once finished, the resource will be marked in the DB as complete, along with metadata.  Although the job is marked as complete, it may still take some time for the leads to be fully processed off the Kafka topic. The best way to get status on this part of the recalculation process is to query the lead funnel for the `minQueuedLeadId` on the `LeadFunnelRecalculation` using the `getLeadFunnelsForSupplySubAccount` operation.
         * @summary Create lead funnel recalculation
         * @param {LeadFunnelRecalculationCreateData} [leadFunnelRecalculationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLeadFunnelRecalculation: function (leadFunnelRecalculationCreateData, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/leadFunnelRecalculations";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication internalBearerToken required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            var needsSerialization = (typeof leadFunnelRecalculationCreateData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(leadFunnelRecalculationCreateData !== undefined ? leadFunnelRecalculationCreateData : {}) : (leadFunnelRecalculationCreateData || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns `LeadFunnelRecalculation` resources according to the specifed criteria. Can be used for either getting the state of a `LeadFunnelRecalculation`, or for seeing the history of recalculations for a supply partner.,
         * @summary Get lead funnel recalculations
         * @param {number} limit
         * @param {Array<number>} [id]
         * @param {Array<number>} [leadId]
         * @param {Array<number>} [supplySubAccountId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadFunnelRecalculations: function (limit, id, leadId, supplySubAccountId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'limit' is not null or undefined
            if (limit === null || limit === undefined) {
                throw new base_1.RequiredError('limit', 'Required parameter limit was null or undefined when calling getLeadFunnelRecalculations.');
            }
            var localVarPath = "/leadFunnelRecalculations";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication internalBearerToken required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (id) {
                localVarQueryParameter['id'] = id;
            }
            if (leadId) {
                localVarQueryParameter['leadId'] = leadId;
            }
            if (supplySubAccountId) {
                localVarQueryParameter['supplySubAccountId'] = supplySubAccountId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the last calculated lead funnels for a supply sub-account according to the specified criteria.  This endpoint is primarily useful for debugging API results on a lead-by-lead basis, or for determining the state of a `LeadFunnelRecalculation`.  A `supplySubAccountId` is required because the data is sharded on that value in the DB.
         * @summary Get lead funnels for supply sub-account
         * @param {number} supplySubAccountId
         * @param {number} limit
         * @param {Array<number>} [id]
         * @param {Array<number>} [leadId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadFunnelsForSupplySubAccount: function (supplySubAccountId, limit, id, leadId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'supplySubAccountId' is not null or undefined
            if (supplySubAccountId === null || supplySubAccountId === undefined) {
                throw new base_1.RequiredError('supplySubAccountId', 'Required parameter supplySubAccountId was null or undefined when calling getLeadFunnelsForSupplySubAccount.');
            }
            // verify required parameter 'limit' is not null or undefined
            if (limit === null || limit === undefined) {
                throw new base_1.RequiredError('limit', 'Required parameter limit was null or undefined when calling getLeadFunnelsForSupplySubAccount.');
            }
            var localVarPath = "/supplySubAccounts/{supplySubAccountId}/leadFunnels"
                .replace("{" + "supplySubAccountId" + "}", encodeURIComponent(String(supplySubAccountId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication internalBearerToken required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (id) {
                localVarQueryParameter['id'] = id;
            }
            if (leadId) {
                localVarQueryParameter['leadId'] = leadId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AdminApi - functional programming interface
 * @export
 */
exports.AdminApiFp = function (configuration) {
    return {
        /**
         * Kicks off a lead funnel recalculation job. The job must be scoped to a single supply sub-account, and may be further limited to a subset of leads for that supply sub-account.  The request will respond immediately with the incomplete `LeadFunnelRecalculation` resource and start a background thread to load the requested leads from the replication hub replica and publish them to the `supply-reporting-lead-recalculations` Kafka topic. Once finished, the resource will be marked in the DB as complete, along with metadata.  Although the job is marked as complete, it may still take some time for the leads to be fully processed off the Kafka topic. The best way to get status on this part of the recalculation process is to query the lead funnel for the `minQueuedLeadId` on the `LeadFunnelRecalculation` using the `getLeadFunnelsForSupplySubAccount` operation.
         * @summary Create lead funnel recalculation
         * @param {LeadFunnelRecalculationCreateData} [leadFunnelRecalculationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLeadFunnelRecalculation: function (leadFunnelRecalculationCreateData, options) {
            var localVarAxiosArgs = exports.AdminApiAxiosParamCreator(configuration).createLeadFunnelRecalculation(leadFunnelRecalculationCreateData, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Returns `LeadFunnelRecalculation` resources according to the specifed criteria. Can be used for either getting the state of a `LeadFunnelRecalculation`, or for seeing the history of recalculations for a supply partner.,
         * @summary Get lead funnel recalculations
         * @param {number} limit
         * @param {Array<number>} [id]
         * @param {Array<number>} [leadId]
         * @param {Array<number>} [supplySubAccountId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadFunnelRecalculations: function (limit, id, leadId, supplySubAccountId, options) {
            var localVarAxiosArgs = exports.AdminApiAxiosParamCreator(configuration).getLeadFunnelRecalculations(limit, id, leadId, supplySubAccountId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get the last calculated lead funnels for a supply sub-account according to the specified criteria.  This endpoint is primarily useful for debugging API results on a lead-by-lead basis, or for determining the state of a `LeadFunnelRecalculation`.  A `supplySubAccountId` is required because the data is sharded on that value in the DB.
         * @summary Get lead funnels for supply sub-account
         * @param {number} supplySubAccountId
         * @param {number} limit
         * @param {Array<number>} [id]
         * @param {Array<number>} [leadId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadFunnelsForSupplySubAccount: function (supplySubAccountId, limit, id, leadId, options) {
            var localVarAxiosArgs = exports.AdminApiAxiosParamCreator(configuration).getLeadFunnelsForSupplySubAccount(supplySubAccountId, limit, id, leadId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * AdminApi - factory interface
 * @export
 */
exports.AdminApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * Kicks off a lead funnel recalculation job. The job must be scoped to a single supply sub-account, and may be further limited to a subset of leads for that supply sub-account.  The request will respond immediately with the incomplete `LeadFunnelRecalculation` resource and start a background thread to load the requested leads from the replication hub replica and publish them to the `supply-reporting-lead-recalculations` Kafka topic. Once finished, the resource will be marked in the DB as complete, along with metadata.  Although the job is marked as complete, it may still take some time for the leads to be fully processed off the Kafka topic. The best way to get status on this part of the recalculation process is to query the lead funnel for the `minQueuedLeadId` on the `LeadFunnelRecalculation` using the `getLeadFunnelsForSupplySubAccount` operation.
         * @summary Create lead funnel recalculation
         * @param {LeadFunnelRecalculationCreateData} [leadFunnelRecalculationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLeadFunnelRecalculation: function (leadFunnelRecalculationCreateData, options) {
            return exports.AdminApiFp(configuration).createLeadFunnelRecalculation(leadFunnelRecalculationCreateData, options)(axios, basePath);
        },
        /**
         * Returns `LeadFunnelRecalculation` resources according to the specifed criteria. Can be used for either getting the state of a `LeadFunnelRecalculation`, or for seeing the history of recalculations for a supply partner.,
         * @summary Get lead funnel recalculations
         * @param {number} limit
         * @param {Array<number>} [id]
         * @param {Array<number>} [leadId]
         * @param {Array<number>} [supplySubAccountId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadFunnelRecalculations: function (limit, id, leadId, supplySubAccountId, options) {
            return exports.AdminApiFp(configuration).getLeadFunnelRecalculations(limit, id, leadId, supplySubAccountId, options)(axios, basePath);
        },
        /**
         * Get the last calculated lead funnels for a supply sub-account according to the specified criteria.  This endpoint is primarily useful for debugging API results on a lead-by-lead basis, or for determining the state of a `LeadFunnelRecalculation`.  A `supplySubAccountId` is required because the data is sharded on that value in the DB.
         * @summary Get lead funnels for supply sub-account
         * @param {number} supplySubAccountId
         * @param {number} limit
         * @param {Array<number>} [id]
         * @param {Array<number>} [leadId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadFunnelsForSupplySubAccount: function (supplySubAccountId, limit, id, leadId, options) {
            return exports.AdminApiFp(configuration).getLeadFunnelsForSupplySubAccount(supplySubAccountId, limit, id, leadId, options)(axios, basePath);
        },
    };
};
/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
var AdminApi = /** @class */ (function (_super) {
    __extends(AdminApi, _super);
    function AdminApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Kicks off a lead funnel recalculation job. The job must be scoped to a single supply sub-account, and may be further limited to a subset of leads for that supply sub-account.  The request will respond immediately with the incomplete `LeadFunnelRecalculation` resource and start a background thread to load the requested leads from the replication hub replica and publish them to the `supply-reporting-lead-recalculations` Kafka topic. Once finished, the resource will be marked in the DB as complete, along with metadata.  Although the job is marked as complete, it may still take some time for the leads to be fully processed off the Kafka topic. The best way to get status on this part of the recalculation process is to query the lead funnel for the `minQueuedLeadId` on the `LeadFunnelRecalculation` using the `getLeadFunnelsForSupplySubAccount` operation.
     * @summary Create lead funnel recalculation
     * @param {LeadFunnelRecalculationCreateData} [leadFunnelRecalculationCreateData]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.createLeadFunnelRecalculation = function (leadFunnelRecalculationCreateData, options) {
        return exports.AdminApiFp(this.configuration).createLeadFunnelRecalculation(leadFunnelRecalculationCreateData, options)(this.axios, this.basePath);
    };
    /**
     * Returns `LeadFunnelRecalculation` resources according to the specifed criteria. Can be used for either getting the state of a `LeadFunnelRecalculation`, or for seeing the history of recalculations for a supply partner.,
     * @summary Get lead funnel recalculations
     * @param {number} limit
     * @param {Array<number>} [id]
     * @param {Array<number>} [leadId]
     * @param {Array<number>} [supplySubAccountId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getLeadFunnelRecalculations = function (limit, id, leadId, supplySubAccountId, options) {
        return exports.AdminApiFp(this.configuration).getLeadFunnelRecalculations(limit, id, leadId, supplySubAccountId, options)(this.axios, this.basePath);
    };
    /**
     * Get the last calculated lead funnels for a supply sub-account according to the specified criteria.  This endpoint is primarily useful for debugging API results on a lead-by-lead basis, or for determining the state of a `LeadFunnelRecalculation`.  A `supplySubAccountId` is required because the data is sharded on that value in the DB.
     * @summary Get lead funnels for supply sub-account
     * @param {number} supplySubAccountId
     * @param {number} limit
     * @param {Array<number>} [id]
     * @param {Array<number>} [leadId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    AdminApi.prototype.getLeadFunnelsForSupplySubAccount = function (supplySubAccountId, limit, id, leadId, options) {
        return exports.AdminApiFp(this.configuration).getLeadFunnelsForSupplySubAccount(supplySubAccountId, limit, id, leadId, options)(this.axios, this.basePath);
    };
    return AdminApi;
}(base_1.BaseAPI));
exports.AdminApi = AdminApi;
/**
 * CreditCardApi - axios parameter creator
 * @export
 */
exports.CreditCardApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Return credit card funnel summaries based upon request parameters
         * @summary Get credit card funnel summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize leads created on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize leads with that credit credit rating.
         * @param {string} startDate Only summarize leads that were created on or after this date.
         * @param {string} endDate Only summarize leads that were created strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreditCardFunnelSummaries: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'subAccountId' is not null or undefined
            if (subAccountId === null || subAccountId === undefined) {
                throw new base_1.RequiredError('subAccountId', 'Required parameter subAccountId was null or undefined when calling getCreditCardFunnelSummaries.');
            }
            // verify required parameter 'groupingKey' is not null or undefined
            if (groupingKey === null || groupingKey === undefined) {
                throw new base_1.RequiredError('groupingKey', 'Required parameter groupingKey was null or undefined when calling getCreditCardFunnelSummaries.');
            }
            // verify required parameter 'startDate' is not null or undefined
            if (startDate === null || startDate === undefined) {
                throw new base_1.RequiredError('startDate', 'Required parameter startDate was null or undefined when calling getCreditCardFunnelSummaries.');
            }
            // verify required parameter 'endDate' is not null or undefined
            if (endDate === null || endDate === undefined) {
                throw new base_1.RequiredError('endDate', 'Required parameter endDate was null or undefined when calling getCreditCardFunnelSummaries.');
            }
            var localVarPath = "/creditCardFunnelSummaries";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication internalBearerToken required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (subAccountId !== undefined) {
                localVarQueryParameter['subAccountId'] = subAccountId;
            }
            if (groupingKey !== undefined) {
                localVarQueryParameter['groupingKey'] = groupingKey;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substr(0, 10) :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substr(0, 10) :
                    endDate;
            }
            if (clientTagKey !== undefined) {
                localVarQueryParameter['clientTagKey'] = clientTagKey;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return credit card payout summaries based upon request parameters
         * @summary Get credit card payout summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
         * @param {string} startDate Only summarize payouts that were booked on or after this date.
         * @param {string} endDate Only summarize payouts that were booked strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreditCardPayoutSummaries: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'subAccountId' is not null or undefined
            if (subAccountId === null || subAccountId === undefined) {
                throw new base_1.RequiredError('subAccountId', 'Required parameter subAccountId was null or undefined when calling getCreditCardPayoutSummaries.');
            }
            // verify required parameter 'groupingKey' is not null or undefined
            if (groupingKey === null || groupingKey === undefined) {
                throw new base_1.RequiredError('groupingKey', 'Required parameter groupingKey was null or undefined when calling getCreditCardPayoutSummaries.');
            }
            // verify required parameter 'startDate' is not null or undefined
            if (startDate === null || startDate === undefined) {
                throw new base_1.RequiredError('startDate', 'Required parameter startDate was null or undefined when calling getCreditCardPayoutSummaries.');
            }
            // verify required parameter 'endDate' is not null or undefined
            if (endDate === null || endDate === undefined) {
                throw new base_1.RequiredError('endDate', 'Required parameter endDate was null or undefined when calling getCreditCardPayoutSummaries.');
            }
            var localVarPath = "/creditCardPayoutSummaries";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication internalBearerToken required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (subAccountId !== undefined) {
                localVarQueryParameter['subAccountId'] = subAccountId;
            }
            if (groupingKey !== undefined) {
                localVarQueryParameter['groupingKey'] = groupingKey;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substr(0, 10) :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substr(0, 10) :
                    endDate;
            }
            if (clientTagKey !== undefined) {
                localVarQueryParameter['clientTagKey'] = clientTagKey;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return credit card payout summaries based upon request parameters. v2 includes sub account financial line items
         * @summary Get credit card payout summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
         * @param {string} startDate Only summarize payouts that were booked on or after this date.
         * @param {string} endDate Only summarize payouts that were booked strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreditCardPayoutSummariesV2: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'subAccountId' is not null or undefined
            if (subAccountId === null || subAccountId === undefined) {
                throw new base_1.RequiredError('subAccountId', 'Required parameter subAccountId was null or undefined when calling getCreditCardPayoutSummariesV2.');
            }
            // verify required parameter 'groupingKey' is not null or undefined
            if (groupingKey === null || groupingKey === undefined) {
                throw new base_1.RequiredError('groupingKey', 'Required parameter groupingKey was null or undefined when calling getCreditCardPayoutSummariesV2.');
            }
            // verify required parameter 'startDate' is not null or undefined
            if (startDate === null || startDate === undefined) {
                throw new base_1.RequiredError('startDate', 'Required parameter startDate was null or undefined when calling getCreditCardPayoutSummariesV2.');
            }
            // verify required parameter 'endDate' is not null or undefined
            if (endDate === null || endDate === undefined) {
                throw new base_1.RequiredError('endDate', 'Required parameter endDate was null or undefined when calling getCreditCardPayoutSummariesV2.');
            }
            var localVarPath = "/v2/creditCardPayoutSummaries";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication internalBearerToken required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (subAccountId !== undefined) {
                localVarQueryParameter['subAccountId'] = subAccountId;
            }
            if (groupingKey !== undefined) {
                localVarQueryParameter['groupingKey'] = groupingKey;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substr(0, 10) :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substr(0, 10) :
                    endDate;
            }
            if (clientTagKey !== undefined) {
                localVarQueryParameter['clientTagKey'] = clientTagKey;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CreditCardApi - functional programming interface
 * @export
 */
exports.CreditCardApiFp = function (configuration) {
    return {
        /**
         * Return credit card funnel summaries based upon request parameters
         * @summary Get credit card funnel summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize leads created on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize leads with that credit credit rating.
         * @param {string} startDate Only summarize leads that were created on or after this date.
         * @param {string} endDate Only summarize leads that were created strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreditCardFunnelSummaries: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            var localVarAxiosArgs = exports.CreditCardApiAxiosParamCreator(configuration).getCreditCardFunnelSummaries(subAccountId, groupingKey, startDate, endDate, clientTagKey, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Return credit card payout summaries based upon request parameters
         * @summary Get credit card payout summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
         * @param {string} startDate Only summarize payouts that were booked on or after this date.
         * @param {string} endDate Only summarize payouts that were booked strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreditCardPayoutSummaries: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            var localVarAxiosArgs = exports.CreditCardApiAxiosParamCreator(configuration).getCreditCardPayoutSummaries(subAccountId, groupingKey, startDate, endDate, clientTagKey, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Return credit card payout summaries based upon request parameters. v2 includes sub account financial line items
         * @summary Get credit card payout summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
         * @param {string} startDate Only summarize payouts that were booked on or after this date.
         * @param {string} endDate Only summarize payouts that were booked strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreditCardPayoutSummariesV2: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            var localVarAxiosArgs = exports.CreditCardApiAxiosParamCreator(configuration).getCreditCardPayoutSummariesV2(subAccountId, groupingKey, startDate, endDate, clientTagKey, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * CreditCardApi - factory interface
 * @export
 */
exports.CreditCardApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * Return credit card funnel summaries based upon request parameters
         * @summary Get credit card funnel summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize leads created on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize leads with that credit credit rating.
         * @param {string} startDate Only summarize leads that were created on or after this date.
         * @param {string} endDate Only summarize leads that were created strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreditCardFunnelSummaries: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            return exports.CreditCardApiFp(configuration).getCreditCardFunnelSummaries(subAccountId, groupingKey, startDate, endDate, clientTagKey, options)(axios, basePath);
        },
        /**
         * Return credit card payout summaries based upon request parameters
         * @summary Get credit card payout summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
         * @param {string} startDate Only summarize payouts that were booked on or after this date.
         * @param {string} endDate Only summarize payouts that were booked strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreditCardPayoutSummaries: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            return exports.CreditCardApiFp(configuration).getCreditCardPayoutSummaries(subAccountId, groupingKey, startDate, endDate, clientTagKey, options)(axios, basePath);
        },
        /**
         * Return credit card payout summaries based upon request parameters. v2 includes sub account financial line items
         * @summary Get credit card payout summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
         * @param {string} startDate Only summarize payouts that were booked on or after this date.
         * @param {string} endDate Only summarize payouts that were booked strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCreditCardPayoutSummariesV2: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            return exports.CreditCardApiFp(configuration).getCreditCardPayoutSummariesV2(subAccountId, groupingKey, startDate, endDate, clientTagKey, options)(axios, basePath);
        },
    };
};
/**
 * CreditCardApi - object-oriented interface
 * @export
 * @class CreditCardApi
 * @extends {BaseAPI}
 */
var CreditCardApi = /** @class */ (function (_super) {
    __extends(CreditCardApi, _super);
    function CreditCardApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Return credit card funnel summaries based upon request parameters
     * @summary Get credit card funnel summaries
     * @param {number} subAccountId Only use data for this sub-account.
     * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize leads created on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize leads with that credit credit rating.
     * @param {string} startDate Only summarize leads that were created on or after this date.
     * @param {string} endDate Only summarize leads that were created strictly before this date.
     * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditCardApi
     */
    CreditCardApi.prototype.getCreditCardFunnelSummaries = function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
        return exports.CreditCardApiFp(this.configuration).getCreditCardFunnelSummaries(subAccountId, groupingKey, startDate, endDate, clientTagKey, options)(this.axios, this.basePath);
    };
    /**
     * Return credit card payout summaries based upon request parameters
     * @summary Get credit card payout summaries
     * @param {number} subAccountId Only use data for this sub-account.
     * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
     * @param {string} startDate Only summarize payouts that were booked on or after this date.
     * @param {string} endDate Only summarize payouts that were booked strictly before this date.
     * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditCardApi
     */
    CreditCardApi.prototype.getCreditCardPayoutSummaries = function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
        return exports.CreditCardApiFp(this.configuration).getCreditCardPayoutSummaries(subAccountId, groupingKey, startDate, endDate, clientTagKey, options)(this.axios, this.basePath);
    };
    /**
     * Return credit card payout summaries based upon request parameters. v2 includes sub account financial line items
     * @summary Get credit card payout summaries
     * @param {number} subAccountId Only use data for this sub-account.
     * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
     * @param {string} startDate Only summarize payouts that were booked on or after this date.
     * @param {string} endDate Only summarize payouts that were booked strictly before this date.
     * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditCardApi
     */
    CreditCardApi.prototype.getCreditCardPayoutSummariesV2 = function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
        return exports.CreditCardApiFp(this.configuration).getCreditCardPayoutSummariesV2(subAccountId, groupingKey, startDate, endDate, clientTagKey, options)(this.axios, this.basePath);
    };
    return CreditCardApi;
}(base_1.BaseAPI));
exports.CreditCardApi = CreditCardApi;
/**
 * LifeInsuranceApi - axios parameter creator
 * @export
 */
exports.LifeInsuranceApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get life insurance funnel summaries
         * @summary Get life insurance funnel summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize leads created on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize leads with that credit credit rating.
         * @param {string} startDate Only summarize leads that were created on or after this date.
         * @param {string} endDate Only summarize leads that were created strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeInsuranceFunnelSummaries: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'subAccountId' is not null or undefined
            if (subAccountId === null || subAccountId === undefined) {
                throw new base_1.RequiredError('subAccountId', 'Required parameter subAccountId was null or undefined when calling getLifeInsuranceFunnelSummaries.');
            }
            // verify required parameter 'groupingKey' is not null or undefined
            if (groupingKey === null || groupingKey === undefined) {
                throw new base_1.RequiredError('groupingKey', 'Required parameter groupingKey was null or undefined when calling getLifeInsuranceFunnelSummaries.');
            }
            // verify required parameter 'startDate' is not null or undefined
            if (startDate === null || startDate === undefined) {
                throw new base_1.RequiredError('startDate', 'Required parameter startDate was null or undefined when calling getLifeInsuranceFunnelSummaries.');
            }
            // verify required parameter 'endDate' is not null or undefined
            if (endDate === null || endDate === undefined) {
                throw new base_1.RequiredError('endDate', 'Required parameter endDate was null or undefined when calling getLifeInsuranceFunnelSummaries.');
            }
            var localVarPath = "/lifeInsuranceFunnelSummaries";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication internalBearerToken required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (subAccountId !== undefined) {
                localVarQueryParameter['subAccountId'] = subAccountId;
            }
            if (groupingKey !== undefined) {
                localVarQueryParameter['groupingKey'] = groupingKey;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substr(0, 10) :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substr(0, 10) :
                    endDate;
            }
            if (clientTagKey !== undefined) {
                localVarQueryParameter['clientTagKey'] = clientTagKey;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get life insurance payout summaries
         * @summary Get life insurance payout summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
         * @param {string} startDate Only summarize payouts that were booked on or after this date.
         * @param {string} endDate Only summarize payouts that were booked strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeInsurancePayoutSummaries: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'subAccountId' is not null or undefined
            if (subAccountId === null || subAccountId === undefined) {
                throw new base_1.RequiredError('subAccountId', 'Required parameter subAccountId was null or undefined when calling getLifeInsurancePayoutSummaries.');
            }
            // verify required parameter 'groupingKey' is not null or undefined
            if (groupingKey === null || groupingKey === undefined) {
                throw new base_1.RequiredError('groupingKey', 'Required parameter groupingKey was null or undefined when calling getLifeInsurancePayoutSummaries.');
            }
            // verify required parameter 'startDate' is not null or undefined
            if (startDate === null || startDate === undefined) {
                throw new base_1.RequiredError('startDate', 'Required parameter startDate was null or undefined when calling getLifeInsurancePayoutSummaries.');
            }
            // verify required parameter 'endDate' is not null or undefined
            if (endDate === null || endDate === undefined) {
                throw new base_1.RequiredError('endDate', 'Required parameter endDate was null or undefined when calling getLifeInsurancePayoutSummaries.');
            }
            var localVarPath = "/lifeInsurancePayoutSummaries";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication internalBearerToken required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (subAccountId !== undefined) {
                localVarQueryParameter['subAccountId'] = subAccountId;
            }
            if (groupingKey !== undefined) {
                localVarQueryParameter['groupingKey'] = groupingKey;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substr(0, 10) :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substr(0, 10) :
                    endDate;
            }
            if (clientTagKey !== undefined) {
                localVarQueryParameter['clientTagKey'] = clientTagKey;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get life insurance payout summaries. v2 includes sub account financial line items
         * @summary Get life insurance payout summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
         * @param {string} startDate Only summarize payouts that were booked on or after this date.
         * @param {string} endDate Only summarize payouts that were booked strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeInsurancePayoutSummariesV2: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'subAccountId' is not null or undefined
            if (subAccountId === null || subAccountId === undefined) {
                throw new base_1.RequiredError('subAccountId', 'Required parameter subAccountId was null or undefined when calling getLifeInsurancePayoutSummariesV2.');
            }
            // verify required parameter 'groupingKey' is not null or undefined
            if (groupingKey === null || groupingKey === undefined) {
                throw new base_1.RequiredError('groupingKey', 'Required parameter groupingKey was null or undefined when calling getLifeInsurancePayoutSummariesV2.');
            }
            // verify required parameter 'startDate' is not null or undefined
            if (startDate === null || startDate === undefined) {
                throw new base_1.RequiredError('startDate', 'Required parameter startDate was null or undefined when calling getLifeInsurancePayoutSummariesV2.');
            }
            // verify required parameter 'endDate' is not null or undefined
            if (endDate === null || endDate === undefined) {
                throw new base_1.RequiredError('endDate', 'Required parameter endDate was null or undefined when calling getLifeInsurancePayoutSummariesV2.');
            }
            var localVarPath = "/v2/lifeInsurancePayoutSummaries";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication internalBearerToken required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (subAccountId !== undefined) {
                localVarQueryParameter['subAccountId'] = subAccountId;
            }
            if (groupingKey !== undefined) {
                localVarQueryParameter['groupingKey'] = groupingKey;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substr(0, 10) :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substr(0, 10) :
                    endDate;
            }
            if (clientTagKey !== undefined) {
                localVarQueryParameter['clientTagKey'] = clientTagKey;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LifeInsuranceApi - functional programming interface
 * @export
 */
exports.LifeInsuranceApiFp = function (configuration) {
    return {
        /**
         * Get life insurance funnel summaries
         * @summary Get life insurance funnel summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize leads created on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize leads with that credit credit rating.
         * @param {string} startDate Only summarize leads that were created on or after this date.
         * @param {string} endDate Only summarize leads that were created strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeInsuranceFunnelSummaries: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            var localVarAxiosArgs = exports.LifeInsuranceApiAxiosParamCreator(configuration).getLifeInsuranceFunnelSummaries(subAccountId, groupingKey, startDate, endDate, clientTagKey, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get life insurance payout summaries
         * @summary Get life insurance payout summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
         * @param {string} startDate Only summarize payouts that were booked on or after this date.
         * @param {string} endDate Only summarize payouts that were booked strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeInsurancePayoutSummaries: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            var localVarAxiosArgs = exports.LifeInsuranceApiAxiosParamCreator(configuration).getLifeInsurancePayoutSummaries(subAccountId, groupingKey, startDate, endDate, clientTagKey, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get life insurance payout summaries. v2 includes sub account financial line items
         * @summary Get life insurance payout summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
         * @param {string} startDate Only summarize payouts that were booked on or after this date.
         * @param {string} endDate Only summarize payouts that were booked strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeInsurancePayoutSummariesV2: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            var localVarAxiosArgs = exports.LifeInsuranceApiAxiosParamCreator(configuration).getLifeInsurancePayoutSummariesV2(subAccountId, groupingKey, startDate, endDate, clientTagKey, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * LifeInsuranceApi - factory interface
 * @export
 */
exports.LifeInsuranceApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * Get life insurance funnel summaries
         * @summary Get life insurance funnel summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize leads created on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize leads with that credit credit rating.
         * @param {string} startDate Only summarize leads that were created on or after this date.
         * @param {string} endDate Only summarize leads that were created strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeInsuranceFunnelSummaries: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            return exports.LifeInsuranceApiFp(configuration).getLifeInsuranceFunnelSummaries(subAccountId, groupingKey, startDate, endDate, clientTagKey, options)(axios, basePath);
        },
        /**
         * Get life insurance payout summaries
         * @summary Get life insurance payout summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
         * @param {string} startDate Only summarize payouts that were booked on or after this date.
         * @param {string} endDate Only summarize payouts that were booked strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeInsurancePayoutSummaries: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            return exports.LifeInsuranceApiFp(configuration).getLifeInsurancePayoutSummaries(subAccountId, groupingKey, startDate, endDate, clientTagKey, options)(axios, basePath);
        },
        /**
         * Get life insurance payout summaries. v2 includes sub account financial line items
         * @summary Get life insurance payout summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
         * @param {string} startDate Only summarize payouts that were booked on or after this date.
         * @param {string} endDate Only summarize payouts that were booked strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLifeInsurancePayoutSummariesV2: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            return exports.LifeInsuranceApiFp(configuration).getLifeInsurancePayoutSummariesV2(subAccountId, groupingKey, startDate, endDate, clientTagKey, options)(axios, basePath);
        },
    };
};
/**
 * LifeInsuranceApi - object-oriented interface
 * @export
 * @class LifeInsuranceApi
 * @extends {BaseAPI}
 */
var LifeInsuranceApi = /** @class */ (function (_super) {
    __extends(LifeInsuranceApi, _super);
    function LifeInsuranceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get life insurance funnel summaries
     * @summary Get life insurance funnel summaries
     * @param {number} subAccountId Only use data for this sub-account.
     * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize leads created on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize leads with that credit credit rating.
     * @param {string} startDate Only summarize leads that were created on or after this date.
     * @param {string} endDate Only summarize leads that were created strictly before this date.
     * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LifeInsuranceApi
     */
    LifeInsuranceApi.prototype.getLifeInsuranceFunnelSummaries = function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
        return exports.LifeInsuranceApiFp(this.configuration).getLifeInsuranceFunnelSummaries(subAccountId, groupingKey, startDate, endDate, clientTagKey, options)(this.axios, this.basePath);
    };
    /**
     * Get life insurance payout summaries
     * @summary Get life insurance payout summaries
     * @param {number} subAccountId Only use data for this sub-account.
     * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
     * @param {string} startDate Only summarize payouts that were booked on or after this date.
     * @param {string} endDate Only summarize payouts that were booked strictly before this date.
     * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LifeInsuranceApi
     */
    LifeInsuranceApi.prototype.getLifeInsurancePayoutSummaries = function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
        return exports.LifeInsuranceApiFp(this.configuration).getLifeInsurancePayoutSummaries(subAccountId, groupingKey, startDate, endDate, clientTagKey, options)(this.axios, this.basePath);
    };
    /**
     * Get life insurance payout summaries. v2 includes sub account financial line items
     * @summary Get life insurance payout summaries
     * @param {number} subAccountId Only use data for this sub-account.
     * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
     * @param {string} startDate Only summarize payouts that were booked on or after this date.
     * @param {string} endDate Only summarize payouts that were booked strictly before this date.
     * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LifeInsuranceApi
     */
    LifeInsuranceApi.prototype.getLifeInsurancePayoutSummariesV2 = function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
        return exports.LifeInsuranceApiFp(this.configuration).getLifeInsurancePayoutSummariesV2(subAccountId, groupingKey, startDate, endDate, clientTagKey, options)(this.axios, this.basePath);
    };
    return LifeInsuranceApi;
}(base_1.BaseAPI));
exports.LifeInsuranceApi = LifeInsuranceApi;
/**
 * LoanApi - axios parameter creator
 * @export
 */
exports.LoanApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get loan funnel summaries
         * @summary Get loan funnel summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize leads created on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize leads with that credit credit rating.
         * @param {string} startDate Only summarize leads that were created on or after this date.
         * @param {string} endDate Only summarize leads that were created strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanFunnelSummaries: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'subAccountId' is not null or undefined
            if (subAccountId === null || subAccountId === undefined) {
                throw new base_1.RequiredError('subAccountId', 'Required parameter subAccountId was null or undefined when calling getLoanFunnelSummaries.');
            }
            // verify required parameter 'groupingKey' is not null or undefined
            if (groupingKey === null || groupingKey === undefined) {
                throw new base_1.RequiredError('groupingKey', 'Required parameter groupingKey was null or undefined when calling getLoanFunnelSummaries.');
            }
            // verify required parameter 'startDate' is not null or undefined
            if (startDate === null || startDate === undefined) {
                throw new base_1.RequiredError('startDate', 'Required parameter startDate was null or undefined when calling getLoanFunnelSummaries.');
            }
            // verify required parameter 'endDate' is not null or undefined
            if (endDate === null || endDate === undefined) {
                throw new base_1.RequiredError('endDate', 'Required parameter endDate was null or undefined when calling getLoanFunnelSummaries.');
            }
            var localVarPath = "/loanFunnelSummaries";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication internalBearerToken required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (subAccountId !== undefined) {
                localVarQueryParameter['subAccountId'] = subAccountId;
            }
            if (groupingKey !== undefined) {
                localVarQueryParameter['groupingKey'] = groupingKey;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substr(0, 10) :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substr(0, 10) :
                    endDate;
            }
            if (clientTagKey !== undefined) {
                localVarQueryParameter['clientTagKey'] = clientTagKey;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get loan payout summaries
         * @summary Get loan payout summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
         * @param {string} startDate Only summarize payouts that were booked on or after this date.
         * @param {string} endDate Only summarize payouts that were booked strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanPayoutSummaries: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'subAccountId' is not null or undefined
            if (subAccountId === null || subAccountId === undefined) {
                throw new base_1.RequiredError('subAccountId', 'Required parameter subAccountId was null or undefined when calling getLoanPayoutSummaries.');
            }
            // verify required parameter 'groupingKey' is not null or undefined
            if (groupingKey === null || groupingKey === undefined) {
                throw new base_1.RequiredError('groupingKey', 'Required parameter groupingKey was null or undefined when calling getLoanPayoutSummaries.');
            }
            // verify required parameter 'startDate' is not null or undefined
            if (startDate === null || startDate === undefined) {
                throw new base_1.RequiredError('startDate', 'Required parameter startDate was null or undefined when calling getLoanPayoutSummaries.');
            }
            // verify required parameter 'endDate' is not null or undefined
            if (endDate === null || endDate === undefined) {
                throw new base_1.RequiredError('endDate', 'Required parameter endDate was null or undefined when calling getLoanPayoutSummaries.');
            }
            var localVarPath = "/loanPayoutSummaries";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication internalBearerToken required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (subAccountId !== undefined) {
                localVarQueryParameter['subAccountId'] = subAccountId;
            }
            if (groupingKey !== undefined) {
                localVarQueryParameter['groupingKey'] = groupingKey;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substr(0, 10) :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substr(0, 10) :
                    endDate;
            }
            if (clientTagKey !== undefined) {
                localVarQueryParameter['clientTagKey'] = clientTagKey;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get loan payout summaries. v2 includes sub account financial line items
         * @summary Get loan payout summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
         * @param {string} startDate Only summarize payouts that were booked on or after this date.
         * @param {string} endDate Only summarize payouts that were booked strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanPayoutSummariesV2: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'subAccountId' is not null or undefined
            if (subAccountId === null || subAccountId === undefined) {
                throw new base_1.RequiredError('subAccountId', 'Required parameter subAccountId was null or undefined when calling getLoanPayoutSummariesV2.');
            }
            // verify required parameter 'groupingKey' is not null or undefined
            if (groupingKey === null || groupingKey === undefined) {
                throw new base_1.RequiredError('groupingKey', 'Required parameter groupingKey was null or undefined when calling getLoanPayoutSummariesV2.');
            }
            // verify required parameter 'startDate' is not null or undefined
            if (startDate === null || startDate === undefined) {
                throw new base_1.RequiredError('startDate', 'Required parameter startDate was null or undefined when calling getLoanPayoutSummariesV2.');
            }
            // verify required parameter 'endDate' is not null or undefined
            if (endDate === null || endDate === undefined) {
                throw new base_1.RequiredError('endDate', 'Required parameter endDate was null or undefined when calling getLoanPayoutSummariesV2.');
            }
            var localVarPath = "/v2/loanPayoutSummaries";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication internalBearerToken required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (subAccountId !== undefined) {
                localVarQueryParameter['subAccountId'] = subAccountId;
            }
            if (groupingKey !== undefined) {
                localVarQueryParameter['groupingKey'] = groupingKey;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substr(0, 10) :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substr(0, 10) :
                    endDate;
            }
            if (clientTagKey !== undefined) {
                localVarQueryParameter['clientTagKey'] = clientTagKey;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LoanApi - functional programming interface
 * @export
 */
exports.LoanApiFp = function (configuration) {
    return {
        /**
         * Get loan funnel summaries
         * @summary Get loan funnel summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize leads created on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize leads with that credit credit rating.
         * @param {string} startDate Only summarize leads that were created on or after this date.
         * @param {string} endDate Only summarize leads that were created strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanFunnelSummaries: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            var localVarAxiosArgs = exports.LoanApiAxiosParamCreator(configuration).getLoanFunnelSummaries(subAccountId, groupingKey, startDate, endDate, clientTagKey, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get loan payout summaries
         * @summary Get loan payout summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
         * @param {string} startDate Only summarize payouts that were booked on or after this date.
         * @param {string} endDate Only summarize payouts that were booked strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanPayoutSummaries: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            var localVarAxiosArgs = exports.LoanApiAxiosParamCreator(configuration).getLoanPayoutSummaries(subAccountId, groupingKey, startDate, endDate, clientTagKey, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get loan payout summaries. v2 includes sub account financial line items
         * @summary Get loan payout summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
         * @param {string} startDate Only summarize payouts that were booked on or after this date.
         * @param {string} endDate Only summarize payouts that were booked strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanPayoutSummariesV2: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            var localVarAxiosArgs = exports.LoanApiAxiosParamCreator(configuration).getLoanPayoutSummariesV2(subAccountId, groupingKey, startDate, endDate, clientTagKey, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * LoanApi - factory interface
 * @export
 */
exports.LoanApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * Get loan funnel summaries
         * @summary Get loan funnel summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize leads created on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize leads with that credit credit rating.
         * @param {string} startDate Only summarize leads that were created on or after this date.
         * @param {string} endDate Only summarize leads that were created strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanFunnelSummaries: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            return exports.LoanApiFp(configuration).getLoanFunnelSummaries(subAccountId, groupingKey, startDate, endDate, clientTagKey, options)(axios, basePath);
        },
        /**
         * Get loan payout summaries
         * @summary Get loan payout summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
         * @param {string} startDate Only summarize payouts that were booked on or after this date.
         * @param {string} endDate Only summarize payouts that were booked strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanPayoutSummaries: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            return exports.LoanApiFp(configuration).getLoanPayoutSummaries(subAccountId, groupingKey, startDate, endDate, clientTagKey, options)(axios, basePath);
        },
        /**
         * Get loan payout summaries. v2 includes sub account financial line items
         * @summary Get loan payout summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
         * @param {string} startDate Only summarize payouts that were booked on or after this date.
         * @param {string} endDate Only summarize payouts that were booked strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanPayoutSummariesV2: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            return exports.LoanApiFp(configuration).getLoanPayoutSummariesV2(subAccountId, groupingKey, startDate, endDate, clientTagKey, options)(axios, basePath);
        },
    };
};
/**
 * LoanApi - object-oriented interface
 * @export
 * @class LoanApi
 * @extends {BaseAPI}
 */
var LoanApi = /** @class */ (function (_super) {
    __extends(LoanApi, _super);
    function LoanApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get loan funnel summaries
     * @summary Get loan funnel summaries
     * @param {number} subAccountId Only use data for this sub-account.
     * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize leads created on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize leads with that credit credit rating.
     * @param {string} startDate Only summarize leads that were created on or after this date.
     * @param {string} endDate Only summarize leads that were created strictly before this date.
     * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApi
     */
    LoanApi.prototype.getLoanFunnelSummaries = function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
        return exports.LoanApiFp(this.configuration).getLoanFunnelSummaries(subAccountId, groupingKey, startDate, endDate, clientTagKey, options)(this.axios, this.basePath);
    };
    /**
     * Get loan payout summaries
     * @summary Get loan payout summaries
     * @param {number} subAccountId Only use data for this sub-account.
     * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
     * @param {string} startDate Only summarize payouts that were booked on or after this date.
     * @param {string} endDate Only summarize payouts that were booked strictly before this date.
     * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApi
     */
    LoanApi.prototype.getLoanPayoutSummaries = function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
        return exports.LoanApiFp(this.configuration).getLoanPayoutSummaries(subAccountId, groupingKey, startDate, endDate, clientTagKey, options)(this.axios, this.basePath);
    };
    /**
     * Get loan payout summaries. v2 includes sub account financial line items
     * @summary Get loan payout summaries
     * @param {number} subAccountId Only use data for this sub-account.
     * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
     * @param {string} startDate Only summarize payouts that were booked on or after this date.
     * @param {string} endDate Only summarize payouts that were booked strictly before this date.
     * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoanApi
     */
    LoanApi.prototype.getLoanPayoutSummariesV2 = function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
        return exports.LoanApiFp(this.configuration).getLoanPayoutSummariesV2(subAccountId, groupingKey, startDate, endDate, clientTagKey, options)(this.axios, this.basePath);
    };
    return LoanApi;
}(base_1.BaseAPI));
exports.LoanApi = LoanApi;
/**
 * SavingsApi - axios parameter creator
 * @export
 */
exports.SavingsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get savings funnel summaries
         * @summary Get savings funnel summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize leads created on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize leads with that credit credit rating.
         * @param {string} startDate Only summarize leads that were created on or after this date.
         * @param {string} endDate Only summarize leads that were created strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsFunnelSummaries: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'subAccountId' is not null or undefined
            if (subAccountId === null || subAccountId === undefined) {
                throw new base_1.RequiredError('subAccountId', 'Required parameter subAccountId was null or undefined when calling getSavingsFunnelSummaries.');
            }
            // verify required parameter 'groupingKey' is not null or undefined
            if (groupingKey === null || groupingKey === undefined) {
                throw new base_1.RequiredError('groupingKey', 'Required parameter groupingKey was null or undefined when calling getSavingsFunnelSummaries.');
            }
            // verify required parameter 'startDate' is not null or undefined
            if (startDate === null || startDate === undefined) {
                throw new base_1.RequiredError('startDate', 'Required parameter startDate was null or undefined when calling getSavingsFunnelSummaries.');
            }
            // verify required parameter 'endDate' is not null or undefined
            if (endDate === null || endDate === undefined) {
                throw new base_1.RequiredError('endDate', 'Required parameter endDate was null or undefined when calling getSavingsFunnelSummaries.');
            }
            var localVarPath = "/savingsFunnelSummaries";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication internalBearerToken required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (subAccountId !== undefined) {
                localVarQueryParameter['subAccountId'] = subAccountId;
            }
            if (groupingKey !== undefined) {
                localVarQueryParameter['groupingKey'] = groupingKey;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substr(0, 10) :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substr(0, 10) :
                    endDate;
            }
            if (clientTagKey !== undefined) {
                localVarQueryParameter['clientTagKey'] = clientTagKey;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get savings payout summaries
         * @summary Get savings payout summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
         * @param {string} startDate Only summarize payouts that were booked on or after this date.
         * @param {string} endDate Only summarize payouts that were booked strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsPayoutSummaries: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'subAccountId' is not null or undefined
            if (subAccountId === null || subAccountId === undefined) {
                throw new base_1.RequiredError('subAccountId', 'Required parameter subAccountId was null or undefined when calling getSavingsPayoutSummaries.');
            }
            // verify required parameter 'groupingKey' is not null or undefined
            if (groupingKey === null || groupingKey === undefined) {
                throw new base_1.RequiredError('groupingKey', 'Required parameter groupingKey was null or undefined when calling getSavingsPayoutSummaries.');
            }
            // verify required parameter 'startDate' is not null or undefined
            if (startDate === null || startDate === undefined) {
                throw new base_1.RequiredError('startDate', 'Required parameter startDate was null or undefined when calling getSavingsPayoutSummaries.');
            }
            // verify required parameter 'endDate' is not null or undefined
            if (endDate === null || endDate === undefined) {
                throw new base_1.RequiredError('endDate', 'Required parameter endDate was null or undefined when calling getSavingsPayoutSummaries.');
            }
            var localVarPath = "/savingsPayoutSummaries";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication internalBearerToken required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (subAccountId !== undefined) {
                localVarQueryParameter['subAccountId'] = subAccountId;
            }
            if (groupingKey !== undefined) {
                localVarQueryParameter['groupingKey'] = groupingKey;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substr(0, 10) :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substr(0, 10) :
                    endDate;
            }
            if (clientTagKey !== undefined) {
                localVarQueryParameter['clientTagKey'] = clientTagKey;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get savings payout summaries. v2 includes sub account financial line items
         * @summary Get savings payout summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
         * @param {string} startDate Only summarize payouts that were booked on or after this date.
         * @param {string} endDate Only summarize payouts that were booked strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsPayoutSummariesV2: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'subAccountId' is not null or undefined
            if (subAccountId === null || subAccountId === undefined) {
                throw new base_1.RequiredError('subAccountId', 'Required parameter subAccountId was null or undefined when calling getSavingsPayoutSummariesV2.');
            }
            // verify required parameter 'groupingKey' is not null or undefined
            if (groupingKey === null || groupingKey === undefined) {
                throw new base_1.RequiredError('groupingKey', 'Required parameter groupingKey was null or undefined when calling getSavingsPayoutSummariesV2.');
            }
            // verify required parameter 'startDate' is not null or undefined
            if (startDate === null || startDate === undefined) {
                throw new base_1.RequiredError('startDate', 'Required parameter startDate was null or undefined when calling getSavingsPayoutSummariesV2.');
            }
            // verify required parameter 'endDate' is not null or undefined
            if (endDate === null || endDate === undefined) {
                throw new base_1.RequiredError('endDate', 'Required parameter endDate was null or undefined when calling getSavingsPayoutSummariesV2.');
            }
            var localVarPath = "/v2/savingsPayoutSummaries";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication internalBearerToken required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                var accessToken = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken()
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }
            if (subAccountId !== undefined) {
                localVarQueryParameter['subAccountId'] = subAccountId;
            }
            if (groupingKey !== undefined) {
                localVarQueryParameter['groupingKey'] = groupingKey;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString().substr(0, 10) :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString().substr(0, 10) :
                    endDate;
            }
            if (clientTagKey !== undefined) {
                localVarQueryParameter['clientTagKey'] = clientTagKey;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SavingsApi - functional programming interface
 * @export
 */
exports.SavingsApiFp = function (configuration) {
    return {
        /**
         * Get savings funnel summaries
         * @summary Get savings funnel summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize leads created on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize leads with that credit credit rating.
         * @param {string} startDate Only summarize leads that were created on or after this date.
         * @param {string} endDate Only summarize leads that were created strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsFunnelSummaries: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            var localVarAxiosArgs = exports.SavingsApiAxiosParamCreator(configuration).getSavingsFunnelSummaries(subAccountId, groupingKey, startDate, endDate, clientTagKey, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get savings payout summaries
         * @summary Get savings payout summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
         * @param {string} startDate Only summarize payouts that were booked on or after this date.
         * @param {string} endDate Only summarize payouts that were booked strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsPayoutSummaries: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            var localVarAxiosArgs = exports.SavingsApiAxiosParamCreator(configuration).getSavingsPayoutSummaries(subAccountId, groupingKey, startDate, endDate, clientTagKey, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get savings payout summaries. v2 includes sub account financial line items
         * @summary Get savings payout summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
         * @param {string} startDate Only summarize payouts that were booked on or after this date.
         * @param {string} endDate Only summarize payouts that were booked strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsPayoutSummariesV2: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            var localVarAxiosArgs = exports.SavingsApiAxiosParamCreator(configuration).getSavingsPayoutSummariesV2(subAccountId, groupingKey, startDate, endDate, clientTagKey, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * SavingsApi - factory interface
 * @export
 */
exports.SavingsApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * Get savings funnel summaries
         * @summary Get savings funnel summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize leads created on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize leads with that credit credit rating.
         * @param {string} startDate Only summarize leads that were created on or after this date.
         * @param {string} endDate Only summarize leads that were created strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsFunnelSummaries: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            return exports.SavingsApiFp(configuration).getSavingsFunnelSummaries(subAccountId, groupingKey, startDate, endDate, clientTagKey, options)(axios, basePath);
        },
        /**
         * Get savings payout summaries
         * @summary Get savings payout summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
         * @param {string} startDate Only summarize payouts that were booked on or after this date.
         * @param {string} endDate Only summarize payouts that were booked strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsPayoutSummaries: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            return exports.SavingsApiFp(configuration).getSavingsPayoutSummaries(subAccountId, groupingKey, startDate, endDate, clientTagKey, options)(axios, basePath);
        },
        /**
         * Get savings payout summaries. v2 includes sub account financial line items
         * @summary Get savings payout summaries
         * @param {number} subAccountId Only use data for this sub-account.
         * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
         * @param {string} startDate Only summarize payouts that were booked on or after this date.
         * @param {string} endDate Only summarize payouts that were booked strictly before this date.
         * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSavingsPayoutSummariesV2: function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
            return exports.SavingsApiFp(configuration).getSavingsPayoutSummariesV2(subAccountId, groupingKey, startDate, endDate, clientTagKey, options)(axios, basePath);
        },
    };
};
/**
 * SavingsApi - object-oriented interface
 * @export
 * @class SavingsApi
 * @extends {BaseAPI}
 */
var SavingsApi = /** @class */ (function (_super) {
    __extends(SavingsApi, _super);
    function SavingsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get savings funnel summaries
     * @summary Get savings funnel summaries
     * @param {number} subAccountId Only use data for this sub-account.
     * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize leads created on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize leads with that credit credit rating.
     * @param {string} startDate Only summarize leads that were created on or after this date.
     * @param {string} endDate Only summarize leads that were created strictly before this date.
     * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SavingsApi
     */
    SavingsApi.prototype.getSavingsFunnelSummaries = function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
        return exports.SavingsApiFp(this.configuration).getSavingsFunnelSummaries(subAccountId, groupingKey, startDate, endDate, clientTagKey, options)(this.axios, this.basePath);
    };
    /**
     * Get savings payout summaries
     * @summary Get savings payout summaries
     * @param {number} subAccountId Only use data for this sub-account.
     * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
     * @param {string} startDate Only summarize payouts that were booked on or after this date.
     * @param {string} endDate Only summarize payouts that were booked strictly before this date.
     * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SavingsApi
     */
    SavingsApi.prototype.getSavingsPayoutSummaries = function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
        return exports.SavingsApiFp(this.configuration).getSavingsPayoutSummaries(subAccountId, groupingKey, startDate, endDate, clientTagKey, options)(this.axios, this.basePath);
    };
    /**
     * Get savings payout summaries. v2 includes sub account financial line items
     * @summary Get savings payout summaries
     * @param {number} subAccountId Only use data for this sub-account.
     * @param {SummaryGroupBy} groupingKey How to group the data.  For example, for &#x60;\&quot;day\&quot;&#x60;, keys might be &#x60;\&quot;2020-07-01\&quot;&#x60;, &#x60;\&quot;2020-07-02\&quot;&#x60;, etc., and each group would summarize payouts booked on that day.  For &#x60;\&quot;credit_rating\&quot;&#x60;, keys might be &#x60;\&quot;poor\&quot;&#x60;, &#x60;\&quot;fair\&quot;&#x60;, &#x60;\&quot;good\&quot;&#x60;, &#x60;\&quot;excellent\&quot;&#x60;, and each bucket would summarize payouts with leads with that credit rating.
     * @param {string} startDate Only summarize payouts that were booked on or after this date.
     * @param {string} endDate Only summarize payouts that were booked strictly before this date.
     * @param {string} [clientTagKey] Required when &#x60;groupingKey&#x60; is &#x60;\&quot;lead_client_tag\&quot;&#x60;. Leads will be grouped according to their value for this client tag. Leads that do not have this client tag will be exlcuded.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SavingsApi
     */
    SavingsApi.prototype.getSavingsPayoutSummariesV2 = function (subAccountId, groupingKey, startDate, endDate, clientTagKey, options) {
        return exports.SavingsApiFp(this.configuration).getSavingsPayoutSummariesV2(subAccountId, groupingKey, startDate, endDate, clientTagKey, options)(this.axios, this.basePath);
    };
    return SavingsApi;
}(base_1.BaseAPI));
exports.SavingsApi = SavingsApi;
